import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const MarketingSupportSelectedAppSlugSetter = lazy(
  () => import('./MarketingSupportSelectedAppSlug'),
)

class MarketingSupportSelectedAppSlugSetterComponent extends ReactWebComponent {
  override render() {
    return (
      <AppProviders>
        <MarketingSupportSelectedAppSlugSetter />
      </AppProviders>
    )
  }
}

customElements.define(
  'marketing-support-selected-app-slug-setter',
  MarketingSupportSelectedAppSlugSetterComponent,
)
